/* @flow @format */

import { type ContextRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as React from 'react';
import qs from 'qs';

import type { Dispatch, StoreState } from '../redux/types';
import { fetchAgreementBegin } from '../redux/reducer/term';
import { signinBegin } from '../redux/reducer/auth';
import { toJapanTime } from '../utils';
import SplashPage from './SplashPage';
import ZkaiPage from './ZkaiPage';

const timelines = [
  {
    title: '同じ家にピザをとどけよう',
    text: '常連客の家にピザを届けます。関数や条件分岐の概念に触れながら、効率的に問題を解決していきます。',
  },
  {
    title: 'クーポンを配ろう',
    text: 'ピザ屋さんの近所を回りながら、お店のクーポンを配ります。関数の応用や変数の導入を通して、汎用的なプログラムの作り方を学びます。',
  },
  {
    title: 'ポスターをつくろう',
    text: 'ピザ屋さんのポスターをデザインします。図形に関する知識を活用しながらプログラムを作成します。',
  },
  {
    title: 'ピザに具をのせよう',
    text: 'ピザの上に具をのせる方法を考えます。具の配置を図形として捉え、図形の概念を応用しながらプログラムを設計します。',
  },
];

type State = {
  loading: boolean,
};

type OwnProps = {|
  ...ContextRouter,
|};

type Props = {
  ...OwnProps,
  signinBegin: typeof signinBegin,
  fetchAgreementBegin: typeof fetchAgreementBegin,

  fetching: boolean,
  active: number | void,
  accepted: boolean,
};

class ZPro5 extends React.Component<Props, State> {
  state = {
    loading: true,
  };

  restoreTitle: ?Function;
  token: string;

  constructor(props: Props) {
    super(props);

    const urlParams = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    if (!urlParams.token) {
      window.location = 'https://proc-error.sonyged.com/403.html';
    }
  }

  componentDidMount() {
    const oldTitle = document.title;
    this.restoreTitle = () => {
      document.title = oldTitle;
    };
    document.title = 'Z-pro 小学5年生';
    const urlParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    this.token = typeof urlParams.token === 'string' ? urlParams.token : '';
    if (!this.token) {
      window.location = 'https://proc-error.sonyged.com/403.html';
      return;
    }

    const { fetchAgreementBegin } = this.props;

    fetchAgreementBegin({
      token: this.token,
      ticketSlug: 'z-pro-5',
      termsOfUseVersion: 'proc/20220606',
      privacyPolicyVersion: 'proc/20220606',
    });

    this.setState({ loading: false });
  }

  componentWillUnmount() {
    if (this.restoreTitle) this.restoreTitle();
  }

  handleStartClick = () => {
    this.props.signinBegin({
      token: this.token,
      ticketSlug: 'z-pro-5',
      termsOfUseVersion: 'proc/20220606',
      privacyPolicyVersion: 'proc/20220606',
    });
  };

  render() {
    const { loading } = this.state;
    const { fetching, accepted, active } = this.props;

    if (loading || fetching) return <SplashPage />;
    return (
      <ZkaiPage
        kind="pizza-a"
        timelines={timelines}
        tagline="Z会小学生コース/小学生タブレットコース 5年生"
        accepted={accepted}
        active={active}
        onStartClick={this.handleStartClick}
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch, _: OwnProps) => ({
  signinBegin: (input) => dispatch(signinBegin(input)),
  fetchAgreementBegin: (input) => dispatch(fetchAgreementBegin(input)),
});

function mapStateToProps(state: StoreState) {
  const {
    term: { privacyPolicySigned, termsOfUseSigned, timestamp },
  } = state;

  const fetching = !timestamp;
  const accepted = privacyPolicySigned && termsOfUseSigned;
  let active = undefined;
  if (!fetching) {
    const japanTime = toJapanTime(new Date(timestamp));
    // Date.getMonth() return value in [0, 11]
    const month = japanTime.getUTCMonth() + 1;
    const dayOfMonth = japanTime.getUTCDate();
    if (1 <= month && month <= 3) {
      // the switching date of course 4 is Jan 5th
      if (month === 1 && dayOfMonth < 5) active = 2;
      else active = 3;
    } else if (4 <= month && month <= 6) {
      active = 0;
    } else if (7 <= month && month <= 9) {
      active = 1;
    } else if (10 <= month && month <= 12) {
      active = 2;
    }
  }

  return { fetching, accepted, active };
}

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(ZPro5);
